import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo1 from "../../assets/Images/logo1.png";
import logo2 from "../../assets/Images/logo2.png";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-800 text-white py-4 border-t border-gray-700">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo & Brand */}
          <div
            className="flex items-center space-x-3 cursor-pointer"
            onClick={() => navigate('/')}
          >
            {/* Light Mode Logo */}
            <img
              src={logo1}
              alt="Logo for Light Mode"
              className="block dark:hidden h-5 md:h-10 w-auto"
            />
            {/* Dark Mode Logo */}
            <img
              src={logo2}
              alt="Logo for Dark Mode"
              className="hidden dark:block h-5 md:h-10 w-auto"
            />
          </div>

          {/* Footer Links */}
          <div className="flex space-x-4 text-sm">
            <a href="/terms" className="hover:text-gray-300 transition">Terms of Service</a>
            <span>•</span>
            <a href="/privacy" className="hover:text-gray-300 transition">Privacy Policy</a>
            <span>•</span>
            <a href="/cookies" className="hover:text-gray-300 transition">Cookie Policy</a>
          </div>

          {/* Copyright */}
          <div className="text-gray-400 text-sm text-center md:text-right">
            © {new Date().getFullYear()} Online Tool Pot. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
